import type { Cadence, FlowKind, Scope } from "@/api/types";

export const SCOPE_LABELS: Record<Scope, string> = {
  all: "Todo",
  personal: "Personal",
  business: "Negocio",
};

export const CADENCE_LABELS: Record<Cadence, string> = {
  weekly: "Semanal",
  biweekly: "Quincenal",
  monthly: "Mensual",
  unknown: "Irregular",
};

export const FLOW_KIND_LABELS: Record<FlowKind, string> = {
  income: "Ingreso",
  expense: "Gasto",
  refund: "Reembolso",
  debt_payment: "Pago de deuda",
  card_payment: "Pago de tarjeta",
  internal_transfer: "Transferencia interna",
  transfer_out: "Transferencia enviada",
  transfer_in: "Transferencia recibida",
  excluded: "Excluida",
};

export function accountTypeLabel(type: string, subtype: string | null): string {
  const s = (subtype ?? "").toLowerCase();
  if (s === "checking") return "Cheques";
  if (s === "savings") return "Ahorros";
  if (s === "credit card") return "Tarjeta de crédito";
  if (s === "line of credit") return "Línea de crédito";
  if (s === "mortgage") return "Hipoteca";
  if (s === "auto") return "Préstamo de auto";
  if (s === "student") return "Préstamo estudiantil";
  if (s === "money market") return "Money market";
  if (s === "cd") return "Certificado de depósito";
  if (type === "depository") return "Depósito";
  if (type === "credit") return "Crédito";
  if (type === "loan") return "Préstamo";
  if (type === "investment" || type === "brokerage") return "Inversión";
  return subtype ?? type;
}

export const SYNC_STATUS_LABELS = {
  running: "Sincronizando…",
  ok: "Completada",
  error: "Con error",
  skipped: "Omitida",
} as const;
